import React from 'react';
import styles from './TopBar10.module.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar10 = ({ branding }) => {
  const { user } = useAuth();

  const phone =
    branding?.phones?.join(" | ") ||
    user?.companyPhone ||
    "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const facebookUrl =
    branding?.socials?.facebook || "#";

  const instagramUrl =
    branding?.socials?.instagram || "#";

  const twitterUrl =
    branding?.socials?.x || "#";

  return (
    <div className={styles.topBar}>
      <div className={styles.container}>
        
        {/* Left Side: Contact Bubbles */}
        <div className={styles.bubbleGroup}>
          
          <div className={`${styles.bubble} ${styles.float1}`}>
            <div className={styles.iconCircle}>
              <FaPhoneAlt />
            </div>
            <span className={styles.bubbleText}>{phone}</span>
          </div>

          <div className={`${styles.bubble} ${styles.float2}`}>
            <div className={styles.iconCircle}>
              <FaEnvelope />
            </div>
            <span className={styles.bubbleText}>{email}</span>
          </div>

        </div>

        {/* Right Side: Social Orbs */}
        <div className={styles.socialOrbContainer}>
          <div className={styles.orbLabel}>Let's Connect</div>

          <div className={styles.orbs}>
            
            <a href={facebookUrl} target="_blank" rel="noreferrer" className={styles.socialOrb}>
              <FaFacebookF />
            </a>

            <a href={instagramUrl} target="_blank" rel="noreferrer" className={styles.socialOrb}>
              <FaInstagram />
            </a>

            <a href={twitterUrl} target="_blank" rel="noreferrer" className={styles.socialOrb}>
              <FaTwitter />
            </a>

          </div>
        </div>

      </div>
    </div>
  );
};

export default TopBar10;